import { Navigate, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { EmpresasProvider } from "./empresas-context";
import { EmpresasLayout } from "./empresas-layout";
import { EmpresasTable } from "./empresas-table";
import { EmpresaRoutes } from "./empresa-routes";
import { InscripcionForm } from "./inscripcion-form";

export function EmpresasRoutes() {
  return (
    <RoleGuard roles={["empresas"]}>
      <EmpresasProvider>
        <Routes>
          <Route path="/" element={<EmpresasLayout />}>
            <Route index element={<Navigate to="search" replace />} />

            <Route path="search" element={<EmpresasTable />} />
            <Route path="create" element={<InscripcionForm />} />
            <Route path="inscribir" element={<InscripcionForm />} />
            <Route path=":empresa_id/*" element={<EmpresaRoutes />} />

            <Route path="*" element="EmpresasRoutes: Page Not Found" />
          </Route>
        </Routes>
      </EmpresasProvider>
    </RoleGuard>
  );
}
